export const SDB_ENABLED_SET = "systemSettings/SDB_ENABLED_SET"
export const SDB_MINIMAL_VALUE_SET = "systemSettings/SDB_MINIMAL_VALUE_SET"
export const SDB_USER_EXCEPTION_TYPE_SET = "systemSettings/SDB_USER_EXCEPTION_TYPE_SET"
export const SDB_EXCEPTION_USERS_SET = "systemSettings/SDB_EXCEPTION_USERS_SET"


// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/sdb/actionTypes.js